import React from "react";

import { useNavigate } from "react-router-dom";

import HttpError from "commons/utils/errors/HttpError";
import storage from "commons/utils/storage";

import { useUserActionsContext } from "context/user";

import useUserApi from "hooks/api/private/useUserApi";

import ErrorWhoAmI from "pages/error/ErrorWhoAmI";

function Root() {
    const navigate = useNavigate();

    const { whoAmI } = useUserApi();

    const { storeUserData } = useUserActionsContext();

    const [errorMessage, setErrorMessage] = React.useState<string | undefined>(undefined);

    React.useEffect(() => {
        const [apiCall, abortController] = whoAmI();

        apiCall
            .then((response) => {
                storeUserData(response);

                const afterLoginRedirect = storage.get("afterLoginRedirect");

                storage.remove("afterLoginRedirect");

                if (afterLoginRedirect) {
                    navigate(afterLoginRedirect);
                } else {
                    navigate("/dashboard");
                }
            })
            .catch((error) => {
                if (
                    error instanceof HttpError &&
                    (error.responseStatus === "401" || error.responseStatus === "403")
                ) {
                    setErrorMessage("Il tuo utente non è abilitato all'accesso.");
                } else {
                    setErrorMessage("C'è stato un errore durante l'accesso.");
                }
            });

        return () => {
            abortController.abort();
        };
    }, [whoAmI, storeUserData, navigate]);

    return (
        <div>
            {errorMessage === undefined && (
                <div style={{ padding: "8px" }}>
                    {"Attendi: verifica della sessione in corso..."}
                </div>
            )}

            {errorMessage !== undefined && <ErrorWhoAmI message={errorMessage} />}
        </div>
    );
}

export default Root;
